import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import TruckColorIcon from '../../../../../../../common/icons/icr_envio.svg';

import ChangeDispatchDate from '../../../forms/changeDispatchDate/ChangeDispatchDate';
import MotiveTitle from '../MotiveTitle';

const ChangeDispatchDateMobile = ({ ...props }) => {
  const {
    motiveId,
    orderId,
    sku,
    product,
    profile,
    selfServiceStatus,
    onData,
  } = props;

  return (
    <Box>
      <MotiveTitle
        icon={TruckColorIcon}
        title="Despacho y retiro"
        subtitle="Cambiar la fecha de mi despacho"
        mobile
      />
      <ChangeDispatchDate
        mobile
        motiveId={motiveId}
        product={product}
        orderId={orderId}
        sku={sku}
        profile={profile}
        selfServiceStatus={selfServiceStatus}
        onData={onData}
        type="1"
      />
    </Box>
  );
};

ChangeDispatchDateMobile.propTypes = {
  motiveId: PropTypes.string,
  orderId: PropTypes.string,
  sku: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  selfServiceStatus: PropTypes.string,
  onData: PropTypes.func,
};

export default ChangeDispatchDateMobile;
